<template>
  <div class="container">
    <custom-select
      :label="label"
      :value="value"
      :name="name"
      @input="onChange"
      @click="$emit('click')"
      :items="companias"
      :validation-error="error"
      valueDisabled="Seleccioná la empresa"
    />
  </div>
</template>

<script>
import { companias } from "@/config/constants";
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "Company",
  components: { CustomSelect },
  props: {
    value: String,
    name: String,
    label: String,
    validationError: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      checked: false
    };
  },
  computed: {
    companias() {
      return companias;
    },
    error() {
      if (this.checked) {
        if (this.validationError) {
          return this.validationError;
        } else if (this.isVoid()) {
          return "Tenés que seleccionar tu compañia";
        } else if (!this.isValid()) {
          return "La opción no es válida";
        }
      }
      return null;
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    },
    checkValid() {
      this.checked = true;
      return this.isValid();
    },
    isVoid() {
      return this.value == null || this.value.trim() === "";
    },
    isValid() {
      if (this.required) {
        return !this.isVoid();
      }
      return true;
    }
  }
};
</script>
